import React from "react";
import {
  StackedCarousel as ReactStackedCarousel,
  ResponsiveContainer
} from "react-stacked-center-carousel";

// ---------------------------------------------------------------------------
// Slide component
// ---------------------------------------------------------------------------
const Slide = React.memo(function (props) {
  const { data, dataIndex, isCenterSlide, swipeTo, slideIndex } = props;
  const image = data[dataIndex];

  return (
    <div className="card-card" draggable={false}>
      <div className={`cover fill ${isCenterSlide ? "off" : "on"}`}>
        <div
          className="card-overlay fill"
          onClick={() => {
            if (!isCenterSlide) swipeTo(slideIndex);
          }}
        />
      </div>
      <div className="detail fill">
        <img
          className="cover-image fill"
          src={image}
          alt={`Preview ${dataIndex + 1}`}
        />
      </div>
    </div>
  );
});

// ---------------------------------------------------------------------------
// StackedCarousel wrapper
// ---------------------------------------------------------------------------
const StackedCarousel = ({ images }) => {
  const ref = React.useRef();

  // auto‑play
  React.useEffect(() => {
    const iv = setInterval(() => ref.current?.goNext(), 3000);
    return () => clearInterval(iv);
  }, []);

  if (!images || images.length === 0) return null;

  return (
    <div className="stacked-carousel-container">
      <ResponsiveContainer
        carouselRef={ref}
        render={(parentWidth, carouselRef) => {
          /* ---------------- width driven by width ---------------- */
          const rootFont = parseFloat(
            getComputedStyle(document.documentElement).fontSize || "16px"
          );
          let slideWidth;
          if (parentWidth < 576) slideWidth = parentWidth * 0.85;
          else if (parentWidth < 768) slideWidth = parentWidth * 0.75;
          else slideWidth = Math.min(parentWidth * 0.7, 35 * rootFont);

          /* ---------------- NEW height guard ---------------- */
          const maxHeight = window.innerHeight * 0.7;     // 70 % of viewport
          const slideHeight = (slideWidth * 3) / 4;       // 4:3 ratio
          if (slideHeight > maxHeight) {
            slideWidth = (maxHeight * 4) / 3;             // shrink width
          }

          /* ---------------- maxVisibleSlide / scales -------- */
          let maxVisible;
          if (parentWidth < 768) maxVisible = images.length >= 3 ? 3 : 1;
          else if (images.length <= 2) maxVisible = 1;
          else if (images.length <= 4) maxVisible = 3;
          else maxVisible = 5;

          const scales = {
            1: [1, 0.8],
            3: [1, 0.8, 0.65],
            5: [1, 0.8, 0.65, 0.5, 0.35]
          }[maxVisible];

          return (
            <ReactStackedCarousel
              ref={carouselRef}
              slideComponent={Slide}
              slideWidth={slideWidth}
              carouselWidth={parentWidth}
              data={images}
              maxVisibleSlide={maxVisible}
              customScales={scales}
              disableSwipe
              transitionTime={450}
            />
          );
        }}
      />
    </div>
  );
};

export default StackedCarousel;
